import { motion } from 'framer-motion';

const ServiceCard = ({ icon: Icon, title, description, index }) => {
  return (
    <motion.div
      className="service-card"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      data-testid={`service-card-${index}`}
    >
      <Icon className="service-card-icon" strokeWidth={1} />
      <h3 className="service-card-title">{title}</h3>
      <p className="service-card-description">{description}</p>
    </motion.div>
  );
};

export default ServiceCard;
